import { render, staticRenderFns } from "./SBSSessionsWidget.vue?vue&type=template&id=d1ae13ac&scoped=true"
import script from "./SBSSessionsWidget.vue?vue&type=script&lang=js"
export * from "./SBSSessionsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ae13ac",
  null
  
)

export default component.exports